<template>
  <BContainer>
    <BRow class="justify-content-center pb-5">
      <BCol cols="12" md="8" v-if="player">
        <BRow>
          <BCol class="mb-5" cols="12">
            <h4 class="text-white text-center mt-5 mb-3">{{ $t('playerProfile.more_region_bottom') }} {{ translateRegion(player.region_id) }}</h4>
          </BCol>
          <BCol class="p-3" cols="6" v-for="p in region.players.slice(0,6)" :key="p.id">
            <BRow>
              <BCol cols="12" md="5">

                <div v-if="p.linked_list && p.linked_list.length > 1" class="multi-faces">
                  <RouterLink v-for="(r, ix) in p.linked_list" :key="r.id" :to="{ name: 'player.profile', params: { id: p.url } }">
                    <img :src="getPlayerImage(r.id)" :alt="r.name" width="100%" :class="`multi-img-side image-${ix}`" />
                  </RouterLink>

                  <RouterLink v-if="p.linked_list && p.linked_list.length > 1" :to="{ name: 'player.profile', params: { id: p.url } }">
                    <img :src="getPlayerImage(p.id)" alt="Profile image" :class="`multi-img-side image-big`">
                  </RouterLink>
                </div>

                <RouterLink v-if="!p.linked_list" :to="{ name: 'player.profile', params: { id: p.url } }">
                  <img :src="getPlayerImage(p.id)" :alt="p.short_name" class="border-round card-img-side">
                </RouterLink>
                <RouterLink v-if="p.linked_list && p.linked_list.length == 1" :to="{ name: 'player.profile', params: { id: p.url } }">
                  <img :src="getPlayerImage(p.id)" :alt="p.short_name" class="card-img-side">
                  <img v-for="r in p.linked_list" :key="r.id" :src="getPlayerImage(r.id)" width="70%" class="relative-image" />
                </RouterLink>
      
              </BCol>
              <BCol cols="12" md="7" class="align-self-center p-0">
                <div class="info_player">
                  <div class="country_player text-md-left text-center text-white ">{{ translateIsoCountry(p.country_iso_3) }}</div>
                  <div class="title_player text-md-left text-center">
                    <RouterLink :to="{ name: 'player.profile', params: { id: p.url } }">
                      {{ p.title }}
                    </RouterLink>
                  </div>
                  <div class="long_player text-md-left text-center">
                    <RouterLink class="text-md-left text-center" :to="{ name: 'player.profile', params: { id: p.url } }">
                      {{ p.short_name }}
                    </RouterLink>
                  </div>
                </div>
              </BCol>
            </BRow>
          </BCol>
        </BRow>
        <BCollapse id="more-players" class="pt-4 row" :class="{'visible': show_more }">
          <BCol class="mb-5" cols="6" v-for="p in region.players.slice(6)" :key="p.id">
            <BRow>
              <BCol cols="12" md="5">

                <div v-if="p.linked_list && p.linked_list.length > 1" class="multi-faces">
                  <RouterLink v-for="(r, ix) in p.linked_list" :key="r.id" :to="{ name: 'player.profile', params: { id: p.url } }">
                    <img :src="getPlayerImage(r.id)" :alt="r.name" width="100%" :class="`multi-img-side image-${ix}`" />
                  </RouterLink>

                  <RouterLink v-if="p.linked_list && p.linked_list.length > 1" :to="{ name: 'player.profile', params: { id: p.url } }">
                    <img :src="getPlayerImage(p.id)" alt="Profile image" :class="`multi-img-side image-big`">
                  </RouterLink>
                </div>

                <RouterLink v-if="!p.linked_list" :to="{ name: 'player.profile', params: { id: p.url } }">
                  <img :src="getPlayerImage(p.id)" :alt="p.short_name" class="border-round card-img-side">
                </RouterLink>

                <RouterLink v-if="p.linked_list && p.linked_list.length == 1" :to="{ name: 'player.profile', params: { id: p.url } }">
                  <img :src="getPlayerImage(p.id)" :alt="p.short_name" class="card-img-side">
                  <img v-for="r in p.linked_list" :key="r.id" :src="getPlayerImage(r.id)" class="relative-image" />
                </RouterLink>
      
              </BCol>
              <BCol cols="12" md="7" class="align-self-center p-0">
                <div class="info_player">
                  <div class="country_player text-md-left text-center text-white ">{{ translateIsoCountry(p.country_iso_3) }}</div>
                  <div class="title_player text-md-left text-center">
                    <RouterLink :to="{ name: 'player.profile', params: { id: p.url } }">
                      {{ p.title }}
                    </RouterLink>
                  </div>
                  <div class="long_player text-md-left text-center">
                    <RouterLink class="text-md-left text-center" :to="{ name: 'player.profile', params: { id: p.url } }">
                      {{ p.short_name }}
                    </RouterLink>
                  </div>
                </div>
              </BCol>
            </BRow>
          </BCol>
        </BCollapse>
        <BRow>
          <BCol cols="12 text-center">
            <BButton v-b-toggle.more-players variant="primary">{{ $t('list.show_more') }} {{ translateRegion(player.region_id) }}</BButton>
          </BCol>
        </BRow>
      </BCol>
    </BRow>
  </BContainer>

</template>

<script>
  import { kebabCase } from 'lodash'
  import utils from '@/mixins/utils'
  
  export default {
    name: 'MorePlayers',
    props: {
      player: [Object],
      region: [Object, Array]
    },
    data() {
      return {
        show_more: false
      }
    },
    mixins: [utils],
    methods: {
      kebabCase,
      showMorePlayers() {
        this.show_more = !this.show_more

        if(this.show_more)
          this.text = `Show less Power Players`
        else
          this.text = `Show more Power Players`
      }
    }
  }
  
</script>

<style lang="scss">

  .title_player {
    font-size: 18px;
    font-weight: 900;
    line-height: 21px;
    margin-bottom: 10px;
    a {
      color: var(--app-color-white) !important;
    }
  }

  .players_general_more {
    position: relative;
    padding: 65px auto;
    padding: 15px;
    background: #191919f2;

    .multi-faces {
      min-height: 180px;
    }

    img {
      width: 100%;
      border-radius: 100%;
      background: var(--app-color-coin);

      &.multi-img-side {
        position: absolute;
        max-width: 100px;

        &.image-0 {
          top: 0;
          left: 0;
        }

        &.image-1 {
          top: 0;
          right: 0;
        }

        &.image-2 {
          bottom: 0;
          left: 0;
        }

        &.image-big {
          bottom: 0;
          right: 0;
          width: 75px;
          background-color: var(--app-color-black) !important;
        }
      }

      &.relative-image {
        position: absolute;
        width: 50%;
        bottom: -35px;
        right: 0;
        background: var(--app-color-light);
      }
    }

    .long_player a {
      font-size: 16px;
      padding: 3px;
      background-color: var(--app-color-coin);
      color: var(--app-color-black);
    }
  }

</style>